import Axios from "axios";
import getFixelDataMock from "../devData/getFixelDataMock";
import axios from "axios";
import Firebase from "./firebase";

export const wpUrl = getWpAjaxUrl();

const axiosShopWrapper = async (method, url, data) => {
  if (!["get", "post", "put", "delete"].includes(method))
    throw new Error("Unknown method");
  try {
    const res = await Axios[method](url, data);
    return res;
  } catch (e) {
    console.log('axiosShopWrapper',e.message||e);
  }
};


export const getFixelData = async (method, url, data) => {
  if (!["get", "post", "put", "delete"].includes(method))
    throw new Error("Unknown method");

  if(process.env.NODE_ENV !== 'production'){// mock a request
    return later(100,getFixelDataMock());
  }else {
    let form_data = formDataFromObj(data);
      return await Axios[method](url, form_data);
  }
}

export function formDataFromObj(data){
  const form_data = new FormData();
  for (const [key, value] of Object.entries(data)) {
    form_data.append(key, value);
  }
  return form_data;
}

/**
 *
 * @param data
 * @returns {Promise<void>}
 */
export async function withToken(data){
  const token = await Firebase.getUserToken();
  data.append('token',token);
}

/**
 *
 * @param url
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const formDataWithToken = async (url, data) => {
    const form_data = formDataFromObj(data);
    await withToken(form_data);
    try {
      return await axios.post(url, form_data);
    } catch (e) {
      console.log('formDataWithToken',e.message||e);
    }
}

/**
 *
 * @param user
 * @returns {Promise<boolean|AxiosResponse<any>|undefined>}
 */
export const verifyCustomer = async (user) => {
  if(process.env.NODE_ENV !== 'production'){
    return later((value) => {return value}, {data : { data : true, success: true }});
  }
  return formDataWithToken(wpUrl,{user: user.email, action: 'fxl_validate_customer'} );
}

/**
 *
 * @param email
 * @returns {Promise<AxiosResponse<any>|undefined>}
 */
export const doesHaveSegments = (email) => {
  if(process.env.NODE_ENV !== 'production'){
    return later((value)=>{return value}, {data : true});
  }
  return formDataWithToken(wpUrl,{email: email, action: 'fxl_check_segment'} );
}

/**
 * Create segment in FixelAPI and add Fixel script to shop
 * @param user
 * @returns {Promise<AxiosResponse<any>|undefined>}
 */
export const creatCustomer = async (user) => {
  let createCustomerObj = {
    action: 'fxl_create_customer',
    customer: JSON.stringify({email: user.email, name: user.displayName}),
  }
  return formDataWithToken(wpUrl,createCustomerObj);
}

/**
 *
 * @param url
 * @returns {string}
 */
export const getHostname = (url) => {
  try {
    return new URL(url).hostname;
  }catch (e) {
    return window.location.hostname;
  }
}

function later(delay, value) {
  return new Promise(resolve => setTimeout(resolve, delay, value));
}

function getWpAjaxUrl() {
  if(window.ajaxurl){
    return window.ajaxurl;
  }
  if(process.env.wpUrl){
    return process.env.wpUrl;
  }else {
    return `${window.location.protocol}//${window.location.hostname}/wp-admin/`;
  }
}

export default axiosShopWrapper;
